import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=29428ea8&scoped=true&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=29428ea8&lang=less&scoped=true&"
import style1 from "./addShop.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29428ea8",
  null
  
)

export default component.exports